import { createFileRoute } from "@tanstack/react-router";
import { LOCALE_FAQ } from "@/data/faq/locale-copy";
import { buildLocaleFaqHead } from "@/lib/faq/locale-head";
import { LocaleFaqPage } from "@/components/faq/LocaleFaqPage";

export const Route = createFileRoute("/en/faq")({
  loader: () => ({ h: buildLocaleFaqHead("en", LOCALE_FAQ.en) }),
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: () => <LocaleFaqPage copy={LOCALE_FAQ.en} />,
});
